import { DataValidator, IsBoolean, IsNumber, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api from "./api";

interface ToggleAgentUserStatusResponse {
  message: string;
  agent_id: string;
  user_id: number;
  is_agent: number;
}

export class ToggleAgentUserStatusData {
  @Required("status cannot be empty")
  @IsNumber("status must be a number")
  status?: number;
}

const transformAndValidateData = (
  response: ToggleAgentUserStatusResponse
): ToggleAgentUserStatusData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, ToggleAgentUserStatusData);
  } catch (error) {
    console.error("AgentUserToggleStatus data validation failed:", error.message);
    throw error;
  }
};

// 切换智能体管理员启用/禁用
export const toggleAgentUserStatus = async ({ agentId, userId, roleType }: { agentId: string, userId: string, roleType: number }) => {
  const res = await api.post<ToggleAgentUserStatusResponse>('/agent-v2/toggle-agent-user-status', {
    agent_id: agentId,
    user_id: userId,
    role_type: roleType,
  });
  return transformAndValidateData(res.data);
};
